module.exports = __webpack_public_path__ + "static/img/sm_js_1.891a93b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sm/sm_js_1.png
// module id = zGy2
// module chunks = 1